import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Button from "@mui/material/Button";
//import ActionButton from "./actionButton";
import { Checkbox, Divider, InputAdornment } from "@mui/material";
import appTheme from '../appTheme'
import { ThemeProvider } from '@mui/material/styles'

const defaultValues = {
    firstName: "",
    lastName: "",
    zipcode: "",
    houseNumber: "",
    distance: "2",
    birthday: "",
    teamName: "",
    iceFirstName: "",
    iceLastName: "",
    icePhone1: "",
    capnr: "",
    contribution: "",
    medal: false,
}

const ParticipantAdd = () => {

    const [formValues, setFormValues] = useState(defaultValues);

    const handleInputChange = (e) => {
        const { name, value, type, checked} = e.target;
        console.log("Handle change", type, name, value, checked)
        setFormValues({
            ...formValues,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("Hier komt de backend verwerking...",formValues)
    }

    return (
        <ThemeProvider theme={appTheme}>
        <Box id="ParticipantAddFormBox" component="form" autoComplete="off" onSubmit={handleSubmit} sx={{marginTop: '16px', width: '70%'}}>
            <Grid container id="ParticipantAddFormContainer" direction="column" spacing={1}>
                <Grid item>
                    <Typography>LET OP! - Registreer een nieuwe deelnemer incl. sponsorbijdrage!</Typography>
                    <Typography color="error.dark" >Er is alleen recht op spullen en medaille als men van te voren heeft registreerd!</Typography>
                    <Divider sx={{my: '10px'}} />
                </Grid>
                <Grid item id="Item-Firstname">
                    <TextField
                        id="Input-Firstname"
                        name="firstName"
                        label="Voornaam"
                        type="text"
                        variant="standard"
                        required
                        value={formValues.firstName}
                        onChange={handleInputChange}
                        sx={{ width: '50%', backgroundColor: 'common.white'}}
                    />
                </Grid>
                <Grid item id="Item-Lastname">
                    <TextField
                        id="Input-Lastname"
                        name="lastName"
                        label="Achternaam"
                        type="text"
                        variant="standard"
                        required
                        value={formValues.lastName}
                        onChange={handleInputChange}
                        sx={{ width: '50%', backgroundColor: 'common.white'}}
                    />
                </Grid>
                <Grid item id="Item-Zipcode">
                    <TextField
                        id="Input-Zipcode"
                        name="zipcode"
                        label="Postcode"
                        type="text"
                        variant="standard"
                        required
                        value={formValues.zipcode}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                    />
                </Grid>
                <Grid item id="Item-Teamname">
                    <TextField
                        id="Input-Teamname"
                        name="teamName"
                        label="Team"
                        type="text"
                        variant="standard"
                        value={formValues.teamName}
                        onChange={handleInputChange}
                        sx={{ width: '50%', backgroundColor: 'common.white'}}
                    />
                </Grid>
                <Grid item id="Item-Distance">
                    <FormControl sx={{ marginTop: '12px'}} component="fieldset">
                        <FormLabel component="legend">Afstand</FormLabel>
                        <RadioGroup row sx={{ paddingLeft: '10px'}} aria-label="distance" name="distance" value={formValues.distance} onChange={handleInputChange}>
                        <FormControlLabel sx={{ marginRight: '28px'}} value="0.5" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>500 m (kids)</Typography>} />
                        <FormControlLabel sx={{ marginRight: '28px'}} value="1" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>1000 m</Typography>} />
                        <FormControlLabel sx={{ marginRight: '28px'}} value="2" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>2000 m</Typography>} />
                        <FormControlLabel value="4" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>4000 m</Typography>} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item id="Item-Contribution">
                    {/* ToDo: use react-currency-format library */}
                    <TextField
                        id="Input-Contribution"
                        name="contribution"
                        label="Sponsorbijdrage"
                        type="text"
                        variant="standard"
                        InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }}
                        value={formValues.contribution}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                    />
                </Grid>
                <Grid item id="Item-MedalYN">
                    <FormControlLabel
                        name="medal"
                        control={<Checkbox checked={formValues.medal} onChange={handleInputChange} />} 
                        label={<Typography color="text.lighter" >Recht op medaille?</Typography>}
                        labelPlacement="end" />
                </Grid>
                <Grid item sx={{marginTop: '10px'}}>
                    <Divider sx={{marginBottom: '10px'}} />
                    <Button id="SubmitButton" variant="contained" sx={{ fontWeight: 'bold', width: '20%'}} disabled={(!formValues.firstName || !formValues.lastName || !formValues.zipcode)} type="submit" color='secondary' >Submit</Button>
                </Grid>
            </Grid>
        </Box>
        </ThemeProvider>
    )
}

export default ParticipantAdd;